export const SET_OSS_STS_CLIENT = "setOssStsClient";
export const SET_APP_ID = "setAppId";
